export default __webpack_public_path__ + "static/media/banner-howto.a66651a3.png";